<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo [onlyLogoLink]="true" [routePath]="[SCAN_ROUTE_PATH]"/>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button/>
  @if (configService.isAdmin()) {
    <div class="menu">
      <span>{{ configService.currentUser()?.name }}</span>
      <button [matMenuTriggerFor]="menu" matIconButton>
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  }
</div>

<!-- Add other fancy navigations here -->
<mat-menu #menu="matMenu">
  <button (click)="goToAdmin()" mat-menu-item>Admin</button>
  <button (click)="configService.reset()" mat-menu-item>Logga ut</button>
  @if (canInstall()) {
    <button (click)="install()" mat-menu-item>Installera</button>
  }
</mat-menu>